import { EntityActions } from '~/apps/shared/actions/consts';
import { ProductsActions } from '~/apps/pos/shared/actions/consts';
import { GetProductItem } from '../../models';


type PosProductsUIState = {
  currentList: [],
  loading: false,
  errorMessage: string,
  currentPage: number,
};

type PosProductState = {
  entities: {[id: string]: GetProductItem},
  ui: PosProductsUIState,
};

const defaultState: PosProductState = {
  entities: {},
  ui: {
    currentList: [],
    loading: false,
    errorMessage: '',
    currentPage: 0,
  }
};

export function products(state: PosProductState = defaultState, action) {
  switch (action.type) {
    case EntityActions.ADD_ENTITIES:
      return {
        ...state,
        entities: {
          ...state.entities,
          ...action.entities.products,
        }
      };
    case ProductsActions.LOAD_REQUEST:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: true,
          errorMessage: '',
        }
      };
    case ProductsActions.LOAD_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
        }
      };
    case ProductsActions.LOAD_ERROR:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: action.error.errorMessage,
        }
      };
    case ProductsActions.LOAD_LIST_SUCCESS:
      return {
        ...state,
        ui: {
          ...state.ui,
          loading: false,
          errorMessage: '',
          currentList: action.result,
        }
      };
    case ProductsActions.SET_CURRENT_PAGE:
      return {
        ...state,
        ui: {
          ...state.ui,
          currentPage: action.currentPage,
        }
      };
    default:
      return state;
  }
}
